import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  /** O'ng tomondagi amallar — "Yangilash", "Orqaga" kabi. */
  actions?: ReactNode;
  className?: string;
}

/**
 * Har bir ekranning bitta `h1` i.
 *
 * Sarlavha komponentda emas, shu yerda: klaviatura bilan ishlaydigan operator uchun sahifa
 * darajali sarlavha — "qayerdaman" savolining yagona ishonchli javobi, va u har ekranda bir xil
 * darajada bo'lishi kerak.
 */
export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-x-6 gap-y-3', className)}>
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight text-balance">{title}</h1>
        {description ? (
          <p className="text-muted-foreground max-w-prose text-sm">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
